import { _js } from '@ifixit/localize';
import { MouseEvent } from 'react';
import { connect } from 'react-redux';
import checkoutOnShopify from 'Shared/shopify_checkout';
import trackInMatomoAndGA from 'Shared/Analytics/CombinedGAMatomo';

declare global {
   interface Window {
      shared_constants: Record<string, any>;
   }
}

const mapStateToProps = (state: any) => ({
   products: state.headerState.miniCart.products,
});

const Footer = ({ products }: { products: any[] }) => {
   const checkoutButtonAttributes = {
      onClick: (e: MouseEvent) => {
         trackInMatomoAndGA({
            eventCategory: 'Mini Cart',
            eventAction: 'Mini Cart - Btn "Check Out" - Click',
         });
         checkoutOnShopify();
         e.preventDefault();
      },
   };

   const viewCartButtonAttributes = {
      onClick: (): void => {
         trackInMatomoAndGA({
            eventCategory: 'Mini Cart',
            eventAction: 'Mini Cart - Btn "View Cart" - Click',
         });
      },
   };

   return products.length ? (
      <div className="mini-cart-footer">
         <a
            className="mini-cart-button button button-transparent"
            href={window.shared_constants.BaseURI('TAG_CHECKOUT_CART')}
            {...viewCartButtonAttributes}
         >
            {_js('View Cart')}
         </a>
         <a
            className="mini-cart-button button button-action-solid js-check-out-fb-track-button"
            {...checkoutButtonAttributes}
         >
            {_js('Checkout')}
         </a>
      </div>
   ) : (
      <div className="mini-cart-footer">
         <a
            className="mini-cart-button button button-action-solid"
            href={window.shared_constants.BaseURI('STORE')}
         >
            {_js('Browse Our Store')}
         </a>
      </div>
   );
};

export default connect(mapStateToProps)(Footer);
